import { ReactNode } from 'react';
import { Box } from '@chakra-ui/react';
import DetailRow from 'components/widgets/DocumentDetailModal/DetailBody/Row';

type Props = {
  children: ReactNode;
};

const DetailBody = ({ children }: Props) => {
  return <Box>{children}</Box>;
};

DetailBody.Row = DetailRow;

export default DetailBody;
